import React, { Component } from 'react'
import Modal from 'react-modal'
import Img from 'gatsby-image'

Modal.setAppElement('#___gatsby')

class ImgModal extends Component {

  constructor(props)
  {
    super(props)
  }

  state = {
    modalIsOpen: false,
  }

  onOpenModal = () => {
    this.setState({ modalIsOpen: true })
  }

  onCloseModal = () => {
    this.setState({ modalIsOpen: false })
  }

  render() {
    const {value, screenshotLookup} = this.props
    const imglookup = screenshotLookup[value + ".png"]

    return (
      <section>
        <Modal
          className="modal"
          overlayClassName="modal-overlay"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.onCloseModal}
        >
          <button className="close" onClick={this.onCloseModal}>
            <span>&times;</span>
          </button>
          <div className="imgcontainer">
            <Img sizes={imglookup.sizes}/>
            </div>
        </Modal>
        <div className="container image fit">
          <span
            className="logo btn btn-primary video-btn"
            onClick={this.onOpenModal}
          >
            <Img sizes={imglookup.sizes}/>
          </span>
        </div>
      </section>
    )
  }
}

export default ImgModal;




// WEBPACK FOOTER //
// ./src/components/imgmodal.js